import { mergeWithComponentCustomizedStyles } from 'conversional-theme';
import { generateClasses } from "../../utilities/components/styles";
export var Styles = function (theme) {
    return (mergeWithComponentCustomizedStyles(theme, "singleImageSelect", {
        singleImageSelectTextBoxContainer: {
            marginBottom: "8px !important"
        }
    }));
};
export var getStyles = function (theme) { return generateClasses(Styles)(theme); };
